// eslint-disable-next-line import/extensions
import DetailChannel from './DetailChannel';

export default DetailChannel;
